<div class="toggle-container">
  <input
    type="checkbox"
    [id]="id"
    [checked]="checked"
    (change)="onToggleChange($event)"
    [attr.props]="props"
  />
  <label [for]="id" class="toggle-label">
    <span class="toggle-slider"></span>
  </label>
</div>
